import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('like-fill-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.644 4a3.739 3.739 0 0 1 3.304 5.488l-4.3 8.122h10.21a6.857 6.857 0 0 1 6.739 8.121L41.52 42.136A2.286 2.286 0 0 1 39.274 44H8.143a3.429 3.429 0 0 1-3.429-3.429V23.43A3.429 3.429 0 0 1 8.143 20h2.713l.001 24h3.429V19.398L20.502 7.65A6.857 6.857 0 0 1 26.564 4h2.08z",
    fill: props.colors[0],
    fillRule: "evenodd"
  }));
});